/* eslint-disable no-useless-computed-key */
import t from '../../../labels/labelling-utils';
import { tournamentTypeMap } from '../../../utils/tennis';

import { ITournament, TennisCalendarStatus } from './tennis-calendar';

export const base = 'Tutti i tornei';
export const filterCriterion = 'tournamentType';

export const tournamentsStatusMap: { status: TennisCalendarStatus; label: string; courtesyMsg: string }[] = [
  { status: 'FINISHED', label: 'Tornei conclusi', courtesyMsg: t('tennis.calendar.courtesymsg.completed') },
  { status: 'LIVE', label: 'Tornei in corso', courtesyMsg: t('tennis.calendar.courtesymsg.ongoing') },
  { status: 'UPCOMING', label: 'Tornei in programma', courtesyMsg: t('tennis.calendar.courtesymsg.scheduled') },
];

export const getCourtesyMsg = (filter: string | null, defaultFilter: string, base: string) => {
  return filter || defaultFilter !== base
    ? `Non ci sono ${(filter || defaultFilter) === 'GrandSlam' ? '' : 'tornei'} ${
        (filter || defaultFilter) === 'Masters'
          ? tournamentTypeMap.Masters.customName
          : tournamentTypeMap[filter || defaultFilter].label
      } in questa sezione`
    : null;
};

export const handleScroll = (wrapperRef: React.RefObject<HTMLDivElement>, status: string) => {
  const active = wrapperRef.current?.querySelector(`#${status}`);
  active?.scrollIntoView({ behavior: 'smooth' });
};

export const hasOngoing = (array: ITournament[]) => array.some((tournament) => tournament.status === 'LIVE');
export const hasScheduled = (array: ITournament[]) => array.some((tournament) => tournament.status === 'UPCOMING');
